// extracted by mini-css-extract-plugin
module.exports = {"CoverSection1":"CoverSection1_CoverSection1__rtalX"};